var franchiseSliderFull = new Swiper('.franchise-hero-carousel', {
    effect: 'fade',
    loop: true,
    pagination: false,
    simulateTouch: false, 
    allowTouchMove: false,
    autoplay: {
        delay: franchiseAutoplay,
      }
});
